import React from "react";

import Heading2Paragraph from '../titles/heading2-paragraph';
import FeatureSectionRow from '../features/featuresection-row';
import SectionContainer from '../containers/section-container';
import ScrollableAnchor from 'react-scrollable-anchor'

export default class FeatureContainer extends React.Component {
    render() {
        return (
            <ScrollableAnchor id={'about-anchor'}>
                <SectionContainer class="margin-top">
                    <Heading2Paragraph content={ this.props.titleContent } />
                    <FeatureSectionRow featureSectionItems={ this.props.featureSectionItems }/>
                </SectionContainer>
            </ScrollableAnchor>
        )
    };
};


// WEBPACK FOOTER //
// ./src/components/containers/featuresection-container.jsx